import { inject, Injectable, signal, TemplateRef } from '@angular/core';
import { PostMessageService } from './post-message.service';

export interface Toast {
  body: string;
  header?: string;
  template?: TemplateRef<any>;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _postMessageService = inject(PostMessageService);
  private _toasts = signal<Toast[]>([]);
  private readonly _defaultDelay = 5000;
  readonly toasts = this._toasts.asReadonly();

  show(toast: Toast) {
    this._postMessageService.postMessageScrollIntoView();
    this._toasts.update((toasts) => [...toasts, toast]);
  }

  remove(toast: Toast) {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  clear() {
    this._toasts.set([]);
  }

  showStandard(
    body: string,
    header?: string,
    template?: TemplateRef<any>,
    delay = this._defaultDelay,
  ) {
    this.show({ header, body, template, delay });
  }

  showInfo(
    body: string,
    header?: string,
    template?: TemplateRef<any>,
    delay = this._defaultDelay,
  ) {
    this.show({
      header,
      body,
      template,
      classname: 'bg-info',
      delay,
    });
  }

  showSuccess(
    body: string,
    header?: string,
    template?: TemplateRef<any>,
    delay = this._defaultDelay,
  ) {
    this.show({
      header,
      body,
      template,
      classname: 'bg-success text-light',
      delay,
    });
  }

  showWarning(
    body: string,
    header?: string,
    template?: TemplateRef<any>,
    delay = this._defaultDelay,
  ) {
    this.show({
      header,
      body,
      template,
      classname: 'bg-warning',
      delay,
    });
  }

  showDanger(
    body: string,
    header?: string,
    template?: TemplateRef<any>,
    delay = this._defaultDelay,
  ) {
    this.show({
      header,
      body,
      template,
      classname: 'bg-danger text-light',
      delay,
    });
  }
}
